export const isDevelopment = process.env.NODE_ENV === 'development';
export const baseUrl = process.env.REACT_APP_PUBLIC_HTTP_BASE_URL || '';
export const backendUrl = process.env.REACT_APP_PUBLIC_HTTP_BACKEND_URL || '';
export const appVersion = process.env.REACT_APP_VERSION;
export const apiKey = process.env.REACT_APP_API_KEY;
